










































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, { ALERT_TYPE, VIEW_MODE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import AgencySelectDialogComponent from '@/components/AgencySelectDialogComponent.vue'
import LabelPrintDialogComponent from '@/components/LabelPrintDialogComponent.vue'
import { Product } from '@/domain/Product'
import { Request } from '@/domain/Request'
import { CustomerInfo } from '@/domain/CustomerInfo'
import { AgencyInfo } from '@/domain/AgencyInfo'
import { User } from '@/domain/User'
import RequestsService from '@/service/RequestsService'
import NumberIssuingService from '@/service/NumberIssuingService'
import LabelPrintService from '@/service/LabelPrintService'
import ScanerService from '@/service/ScanerService'
import ZipService from '@/service/ZipService'
import FileData from '@/domain/FileData'
import { UserInfo } from '@/domain/UserInfo'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    DatePickerComponent,
    CustomerSelectDialogComponent,
    AgencySelectDialogComponent,
    LabelPrintDialogComponent,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const requestsService = RequestsService.instance
      if (to.params["no"] === undefined) {
        /* 新規 */
        vm.$data.viewMode = VIEW_MODE.NEW
        if (typeof to.query["refs"] === "string") {
          const estimateNo = to.query["refs"]
          requestsService.referenceNew(estimateNo).then(x => vm.$data.dto = x)
        } else if (typeof to.query["copy"] === "string") {
          const requestNo = to.query["copy"]
          requestsService.copyNew(requestNo).then(x => vm.$data.dto = x)
        } else {
          requestsService.createNew().then(x => vm.$data.dto = x)
        }
      } else {
        /* 編集 */
        vm.$data.viewMode = VIEW_MODE.VIEW
        requestsService.edit(to.params["no"])
          .then(x => vm.$data.dto = x)
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            vm.$data.dto = new Request()
            vm.$data.viewMode = VIEW_MODE.DELETED
          })
      }
    })
  },
})
export default class MemberRequestEdit extends Mixins(GlobalMixin) {
  numberIssuingService = NumberIssuingService.instance
  labelPrintService = LabelPrintService.instance
  scanerService = ScanerService.instance
  zipService = ZipService.instance

  dto = new Request()
  originalDto = this.dto.clone()
  products: Product[] = []
  productLoadCount = 0

  /* 検体受取者リスト */
  users: User[] = []

  /** ラベル印刷枚数ダイアログ */ 
  labelPrintDialog = false

  /**
   * 保存ボタンの無効
   */
  get disableSubmit() {
    return this.dto.receiptOn !== "" && this.dto.receiptUser.userId === ""
  }

  mounted () {
    this.usersService.findByOccupationCode(1)
      .then((x) => {
        this.users = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.users = []
      })
  }

  /**
   * 画面を遷移する前のチェック
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    if (!this.isView) {
      this.confirm("このページから移動しますか？入力中のデータは保存されません").then(res => {
        res === true ? next() : next(false)
      })
    } else {
      next()
    }
  }
  
  /**
   * 編集モードに切り替える
   */
  onEdit() {
    this.viewMode = VIEW_MODE.EDIT
    this.originalDto = this.dto.clone()
  }

  /**
   * 削除
   */
  onDelete() {
    this.confirm("本当に削除してよろしいですか？").then(res => {
      if (res === true) {
        this.showLoading()
        this.requestsService.delete(this.dto.requestNo)
          .then(() => {
            this.viewMode = VIEW_MODE.DELETED
            this.alert("削除しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("削除に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      }
    })
  }

  /**
   * 編集取消
   */
  onReset() {
    this.confirm("本当に編集を取り消してよろしいですか？").then(res => {
      if (res === true) {
        this.dto = this.originalDto
        this.viewMode =  VIEW_MODE.VIEW
      }
    })
  }

  /**
   * ラベル印刷ボタン
   */
  onPrintLabel() {
    this.labelPrintDialog = true;
  }

  /**
   * ラベル印刷実行
   */
  onLabelPrint(event: number) {
    this.showLoading()
    const storagePeriod = this.dateUtils.lastDate(this.dateUtils.addMonth(this.dto.receiptOn, 4))
    const classificationName = this.dto.sumInfo.classificationNames.ellipsis(8)
    const receiptUser = this.dto.receiptUser.userName
    this.labelPrintService.print(this.dto.requestNo, this.dto.receiptOn, receiptUser, classificationName, storagePeriod, this.dto.specimenReturn, event)
      .then((status) => {
        if (status === true) {
          this.alert(`検体ラベルを${event}枚印刷しました`, ALERT_TYPE.SUCCESS)
        } else {
          this.alert("検体ラベルの印刷に失敗しました", ALERT_TYPE.ERROR)
        }
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検体ラベルの印刷に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 複写作成
   */
  onRequestCopy() {
    this.requestsService.copyNew(this.dto.requestNo).then(x => {
       this.viewMode = VIEW_MODE.NEW
       this.dto = x
    })
  }

  /**
   * 登録ボタンのクリック
   */
  onSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      if (this.viewMode === VIEW_MODE.NEW) {
        /* 登録 */
        if (this.dto.requestNo !== "") {
          this.requestsService.has(this.dto.requestNo)
             .then(status => {
               if (status === true) {
                  this.alert("該当する受付番号の検査依頼は登録済みです", ALERT_TYPE.ERROR)
               } else {
                  /* 過去分の手動登録 */
                  this.save()
               }
             })
        } else {
          this.numberIssuingService.next(this.getNumberIssuingCode(), this.dto.requestOn)
            .then(no => {
              this.dto.requestNo = no
              this.save()
            })
            .catch(error => {
              // eslint-disable-next-line
              console.log(error)
            })
        }
      } else {
        /* 更新 */
        this.save()
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * 明細行を追加
   */
  addDetailLine() {
    this.dto.addDetailLine()
  }

  /**
   * 明細行を削除
   */
  deleteDetailLine(lineIndex: number) {
    this.confirm("明細行を削除してよろしいですか？").then(res => {
      if (res === true) {
        this.dto.deleteDeailLine(lineIndex)
      }
    })
  }

  /**
   * 商品の変更
   */
  onChangeLineItem(lineIndex: number, event: Product) {
    const line = this.dto.details[lineIndex]
    line.inspectionInfo.inspectionCode = event.pk.inspectionCode
    line.inspectionInfo.inspectionName = event.inspectionName
    line.inspectionInfo.inspectionShortName = event.inspectionShortName
    line.inspectionInfo.classificationCode = event.classificationCode
    line.inspectionInfo.otherItem = event.otherItem
    line.inspectionInfo.days = event.days
    line.priceInfo.unitPrice = event.unitPrice
    line.priceInfo.taxRate = this.getTaxRate()
  }

  /**
   * 検体受取者の変更
   */
  onChangeReceipt(event: User) {
    this.dto.receiptUser.userId = event.userId
    this.dto.receiptUser.userName = event.userName
  }

  /**
   * オートコンプリートフィルター
   */
  // eslint-disable-next-line
  usersFilter(item: User, queryText: string, itemText: string) {
    return item.userName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * 商品オートコンプリートフィルター
   */
  // eslint-disable-next-line
  productsFilter(item: Product, queryText: string, itemText: string) {
    return item.inspectionName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * データの保存
   */
  private save() {
    this.showLoading()
    if (this.isNew) {
      this.requestsService.create(this.dto)
        .then((x) => {
          this.dto = x
          this.viewMode = VIEW_MODE.VIEW
          this.alert("保存しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
    } else {
      this.requestsService.update(this.dto)
        .then((x) => {
          this.dto = x
          this.viewMode = VIEW_MODE.VIEW
          this.alert("保存しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
    }
  }

  /**
   * 依頼ファイルスキャン
   */
  onScan() {
    this.showLoading()
    this.scanerService.scan(this.scanSuccess, this.scanError)
  }

  /**
   * 依頼ファイルスキャン成功コールバック
   */
  scanSuccess(blob: Blob) {
    this.dto.requestFile = new FileData({filename: "スキャン文書", content: URL.createObjectURL(blob)})
    this.hideLoading()
  }

  /**
   * 依頼ファイルスキャンエラーコールバック
   */
  scanError(message: string) {
    this.alert(message, ALERT_TYPE.ERROR)
    this.hideLoading()
  }

  /**
   * 依頼ファイルアップロード
   */
  onUpload() {
    // eslint-disable-next-line
    const requestFileInput: any =  this.$refs.requestFileInput
    requestFileInput.$refs.input.click()
  }

  /**
   * 依頼ファイルの登録
   */
  onChangeRequestFile(file: File | undefined) {
    if (file === undefined) {
      this.dto.requestFile = new FileData()
    } else {
      this.readFileAsync(file).then(res => {
        if (res !== undefined) {
          this.dto.requestFile = res
        }
      })
    }
  }

  /**
   * 依頼日変更時
   */
  @Watch("dto.requestOn")
  changeInvoiceOn() {
    this.taxWash()
  }

  /**
   * 検査依頼種別変更時
   */
  @Watch("dto.requestType")
  changeRequestType() {
    this.taxWash()
  }

  /**
   * 顧客変更時に商品マスタの再読み込み
   */
  @Watch("dto.customerInfo")
  chengeCustomer() {
    this.loadProducts()
  }

  /**
   * 代理店変更時に商品マスタの再読み込み
   */
  @Watch("dto.agencyInfo")
  chengeAgency() {
    this.loadProducts()
  }

  /**
   * 郵便番号変更
   */
  @Watch("dto.customerInfo.customerZipCode")
  changeZipCode() {
    const pattern = /^\d{3}-?\d{4}$/g
    if (!this.dto.customerInfo.customerZipCode.match(pattern) || this.dto.customerInfo.customerAddress1 !== "") return

    this.zipService.getAddress(this.dto.customerInfo.customerZipCode)
      .then(x => this.dto.customerInfo.customerAddress1 = x)
  }

  /**
   * 検体着日変更
   */
  @Watch("dto.receiptOn")
  chengeReceiptOn() {
    if (this.dto.receiptOn === "") {
      this.dto.receiptUser = new UserInfo()
    }
  }

  /**
   * 消費税率の取得
   */
  private getTaxRate() {
    /* 輸入検査の場合、免税 */
    return this.dto.requestType === 1 ? 0 : this.taxsService.findByActiveTax(this.dto.requestOn)
  }

  /**
   * 消費税率の洗い替え
   */
  private taxWash() {
    const taxRate = this.getTaxRate()
    this.dto.details.forEach(x => x.priceInfo.taxRate = taxRate)
  }

  /**
   * 商品マスタの再読み込み
   */
  private loadProducts() {
    const isAgency = this.dto.agencyInfo.agencyPrefectureCode !== null && this.dto.agencyInfo.agencyPrefectureCode !== ""
    const prefectureCode = isAgency ? this.dto.agencyInfo.agencyPrefectureCode : this.dto.customerInfo.customerPrefectureCode
    const customerCode = isAgency ? this.dto.agencyInfo.agencyCode : this.dto.customerInfo.customerCode

    if (prefectureCode !== null && prefectureCode !== "" && customerCode !== null && customerCode !== "") {
      this.productsService.findByCustomer(prefectureCode, customerCode)
          .then(x => {
            this.products = x
            if (!this.isView && this.productLoadCount > 2) {  // 最初の２回は洗い替えしない(初期表示時にロードされる)
              /* 既存の明細の単価を洗い替え */
              this.dto.details.forEach(detail => {
                const product = this.products.find(p => p.pk.inspectionCode === detail.inspectionInfo.inspectionCode)
                if (product !== undefined) {
                    detail.priceInfo.unitPrice = product.unitPrice
                }
              })
            }
          })
    }
  }

  /**
   * 顧客選択ダイアログの表示
   */
  openCustomerSelectDialog() {
    if (!this.isView) {
      this.customerSelectDialog = true
    }
  }

  /**
   * 顧客選択クリア
   */
  clearCustomer() {
    this.dto.customerInfo = new CustomerInfo()
  }

  /**
   * 顧客選択
   */
  onCustomerSelected(event: CustomerInfo) {
    this.dto.customerInfo = event
    this.customersService.agency(event.customerPrefectureCode, event.customerCode, event.customerBranchNumber)
        .then((x) => {
          if (x.pk.prefectureCode !== "" && x.pk.code !== "" && x.pk.branchNumber !== "") {
            /* 代理店情報をセット */
            const agencyInfo = new AgencyInfo({agencyPrefectureCode: x.pk.prefectureCode,
                                   agencyCode: x.pk.code,
                                   agencyBranchNumber: x.pk.branchNumber,
                                   agencyName: x.name,
                                   agencyShortName: x.shortName})
            this.dto.agencyInfo = agencyInfo
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
  }

  /**
   * 代理店選択ダイアログの表示
   */
  openAgencySelectDialog() {
    if (!this.isView) {
      this.agencySelectDialog = true
    }
  }

  /**
   * 代理店選択クリア
   */
  clearAgency() {
    this.dto.agencyInfo = new AgencyInfo()
  }

  /**
   * 代理店変更
   */
  changeAgency() {
    if (this.dto.agencyInfo.agencyName === null) {
      this.clearAgency()
    }
  }

  /**
   * 代理店選択
   */
  onAgencySelected(event: AgencyInfo) {
    this.dto.agencyInfo = event
  }

  /**
   * 発番種別コードを取得する
   */
  private getNumberIssuingCode() {
    switch (this.dto.requestType) {
      case 1:
        /* 輸入検査 */
        return NumberIssuingService.REQUEST_IMPORT
      case 2:
        /* 一般検査 日本デリカフーズ分 */
        return NumberIssuingService.REQUEST_CSV
      case 3:
        /* 一般検査 横浜検査センター検査分 */
        return NumberIssuingService.REQUEST_GROUP
      default:
        /* 一般検査 */
        return NumberIssuingService.REQUEST_GENERAL
    }
  }

  /**
   * 編集
   */
  private edit(requestNo: string) {
    /* 編集 */
    this.showLoading()
    this.requestsService.edit(requestNo)
      .then(x => {
        this.viewMode = VIEW_MODE.VIEW
        this.$router.push(`/member/request/edit/${x.requestNo}`)
        this.dto = x
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("データ取得エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
